import { Getters } from 'vuex-smart-module';
import EditableCoursesRequestState from './state';

export default class EditableCoursesRequestGetters extends Getters<EditableCoursesRequestState> {}
